import React, { useCallback } from 'react';

import { TouchableOpacity, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { EPGChannel } from 'custom_modules/react-native-epg';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { EPG_PROGRAM_NO_INFORMATION_ID } from 'config/testID';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import { EpgChannelExtra } from '../../types';
import styles from './styles';

type Props = {
    channel: EPGChannel<EpgChannelExtra>;
    playing: boolean;
    live: boolean;
    isChannelSubscribed?: boolean;
    stickyCellEnabled?: boolean;
    onPress(channel: EPGChannel<EpgChannelExtra>): void;
};

export default function EpgMissingDataCell({
    channel,
    playing,
    live,
    isChannelSubscribed,
    stickyCellEnabled,
    onPress,
}: Props) {
    const { t } = useTranslation();

    const handlePress = useCallback(() => {
        onPress(channel);
    }, [channel, onPress]);

    return (
        <TouchableOpacity
            style={[
                styles.root,
                live && styles.live,
                playing && styles.playing,
                stickyCellEnabled && styles.webStickyProgramCell,
            ]}
            activeOpacity={1}
            onPress={handlePress}
            testID={EPG_PROGRAM_NO_INFORMATION_ID}
        >
            <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                category={ETextCategory.body2}
                color={ETextColor.neutral}
                style={stickyCellEnabled && styles.webStickyText}
            >
                {t(LANGUAGE_KEYS.EPG.EPG_NO_INFO)}
            </Text>
            {!isChannelSubscribed && (
                <View style={styles.unsubscribedOverlay} />
            )}
        </TouchableOpacity>
    );
}
